export default "__VITE_IMAGE_ASSET__cd902d46__";